// extracted by mini-css-extract-plugin
export var checkboxInputRow = "x_tj";
export var checkboxInputColumn = "x_tk";
export var inputOptionRow = "x_qM";
export var inputOptionColumn = "x_qN";